/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import {useI18N} from "../../hoc/withI18N";


const ResultCounter = ({amount, label, pluralLabel}) => {

    const translate = useI18N();
    const html = translate(amount !== 1 ? pluralLabel : label).replace("{0}", "<span>" + amount + "</span>");

    return <h3 className="p-section-result-counter p-margin-none" dangerouslySetInnerHTML={{__html: html}}/>

};

ResultCounter.propTypes = {
    amount: PropTypes.number,
    label: PropTypes.string,
    pluralLabel: PropTypes.string,
};

ResultCounter.defaultProps = {
    pluralLabel: "{0} items",
    label: "{0} item",
    amount: 0,
};

export default ResultCounter;
